import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import Swal from 'sweetalert2';
import axios from 'axios';
import { Container, Grid, Button, MenuItem, Dialog, IconButton, DialogTitle, DialogContent, DialogActions, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Typography, Alert, Backdrop, CircularProgress, } from '@mui/material';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { BASE_URL } from "../../App";
import EditIcon from '@mui/icons-material/Edit';
import dayjs from 'dayjs';
import Box from '@mui/material/Box';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SearchIcon from '@mui/icons-material/Search';
const styles = {
  dialogTitle: {
    backgroundColor: '#0080FF',
    color: '#fff',
	  position: 'sticky',
    top: 0,
    zIndex: 10,
    padding: '10px',
  },
  tableHeaderCell: {
    fontWeight: 'bold',
    backgroundColor: '#f2f2f2',
    padding: '4px',


  },
  customCell: {
    padding: '4px',
  },
  grandTotalCell: {
    textAlign: 'right',
  },
  grandTotalLabel: {
    fontWeight: 'bold',
  },
  grandTotalPopupContent: {
    textAlign: 'center',
  },
  tableRow: {
    fontFamily: 'Times New Roman',
  },
 
  datePickerWrapper: {
    position: 'relative',
    zIndex: 20, 
  },
  datePickerInput: {
    width: '150px',
    height: '40px',
    padding: '8px',
    fontSize: '14px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },
};
const StyledTextField = styled(TextField)({
  width: '100%', // Set to 100% for better responsiveness
  maxWidth: '250px', // Max width to limit excessive stretching on larger screens
  '& .MuiInputBase-root': {
    height: '50px', // Adjust height as needed
    fontSize: '16px',
  },
  '& .MuiInputLabel-root': {
    fontSize: '16px', // Adjust label font size
  },
});

/* Custom styles for react-datepicker */
const customDatePickerStyles = `
.react-datepicker__header {
  background-color: #0080FF;
  border: none;
  color: #fff;
}

.react-datepicker__current-month {
  font-size: 18px; /* Adjust month font size for better readability */
}

.react-datepicker__month-dropdown,
.react-datepicker__year-dropdown {
  width: 100%; /* Use full width */
  max-width: 300px; /* Max width for dropdowns */
  height: auto; /* Automatic height adjustment */
  overflow-y: auto; /* Add scrollbar if content overflows */
}

.react-datepicker__month-dropdown .react-datepicker__month-option,
.react-datepicker__year-dropdown .react-datepicker__year-option {
  height: auto; /* Automatic height adjustment */
  line-height: normal; /* Default line height */
}

.react-datepicker__day {
  height: 40px; /* Adjust date cell height */
  line-height: 40px; /* Adjust line-height for center alignment */
}

/* Media query for smaller screens */
@media (max-width: 600px) {
  .react-datepicker__month-dropdown,
  .react-datepicker__year-dropdown {
    max-width: 100%; /* Full width on smaller screens */
  }

  .react-datepicker__day {
    height: 35px; /* Smaller date cell height for small screens */
    line-height: 35px; /* Adjust line-height */
  }
}
`;

// Inject custom styles into the document head
const injectCustomStyles = () => {
  const styleTag = document.createElement('style');
  styleTag.innerHTML = customDatePickerStyles;
  document.head.appendChild(styleTag);
};
const POdetails = ({
}) => {
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState(tableData);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editedRowIndex, setEditedRowIndex] = useState(null);
  const [editedDocumentType, setEditedDocumentType] = useState('');
  const [editedDocumentType1, setEditedDocumentType1] = useState('');
  const [editedFyear, setEditedFyear] = useState('');
  const [totalReqQty, setTotalReqQty] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [grandTotal, setGrandTotal] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [dataFetched, setDataFetched] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [remarks, setRemarks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dealerOptions, setDealerOptions] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState(null);
  // const [fromDate, setFromDate] = React.useState(dayjs());
  // const [toDate, setToDate] = React.useState(dayjs());
  const [searchTerm, setSearchTerm] = useState('');



  const [items, setItems] = useState([]);
 /// const [searchTerm, setSearchTerm] = useState('');
  const [remarkDropdownOpened, setRemarkDropdownOpened] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState('');
  const [tableData2, setTableData2] = useState([]);
  const [inputsFilled, setInputsFilled] = useState(false);
  const [Reload, setRelod] = useState(0);
  const  login_id= localStorage.getItem("LOGIN_ID");
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
  const [packQty, setPackQty] = useState(null);

    const [ErrorMsg, setErrorMsg] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());

  const handleFromDateChange = (date) => {
    setFromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
  };
  const formatDataForTable = () => {
    return items.map((item) => ({
      'Document Type': item.doctype_code,
      'Document Number': item.doc_no,
      'Document Date': item.doc_date,


    }));
  };

  // const formatToINR = (value) => {
  //   const number = Number(value.replace(/,/g, '')); // Remove commas if present
  //   return number.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }).replace('₹', ''); // Remove ₹ symbol for custom styling
  // };
  const formatToINR = (value) => {
    // Parse the value to a number, handling possible non-numeric input
    const number = parseFloat(value.replace(/,/g, ''));
    
    // Return 'Invalid' if the result is NaN or not a number
    if (isNaN(number)) return '0.00';
  
    // Format the number as currency in INR
    return number.toLocaleString('en-IN', { style: 'currency', currency: 'INR' }).replace('₹', '');
  };
  const handleRemarkChange = (event) => {
    setSelectedRemark(event.target.value);
  };

  const updateTotal = () => {
    let totalReqQtySum = 0;
    let totalAmountSum = 0;
    tableData2.forEach((row) => {
      totalReqQtySum += parseFloat(row.reqQty) || 0;
      totalAmountSum += parseFloat(row.total) || 0;
    });
    setTotalReqQty(totalReqQtySum);
    setTotalAmount(totalAmountSum);
    setGrandTotal(totalAmountSum);
  };

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  // const handleSearch = (event) => {
  //   const value = event.target.value;
  //   setSearchTerm(value);

  //   const filteredRows = tableData.filter((row) =>
  //     Object.values(row).some((field) =>
  //       field.toLowerCase().includes(value.toLowerCase())
  //     )
  //   );

  //   setFilteredData(filteredRows);
  // };




  useEffect(() => {
    // Fetch dealer data from the API
    axios.post(BASE_URL + '/getdealercode', { login_id: login_id })
      .then(response => {
        const data = response.data?.DEALER_CODE || [];
        const options = data.map(dealer => `${dealer.DEALERNAME} - ${dealer.DEALER_CODE}`);
        setDealerOptions(options);
        if (options.length > 0) {
          setSelectedDealer(options[0]);
        }
      })
      .catch(error => {
        console.error('Error fetching dealer data:', error);
      });
  }, []);


const GetTableDatas = () => {
  setLoading(true); // Set loading state to true before fetching data
  setOpen(true);
  
  // Fetch data from the API using selected dealer code, from date, and to date
  axios.post(BASE_URL + '/getordersforammendment', {
    login_id: login_id,
    dealer_code: selectedDealer.split(' - ')[1], // Extract dealer code from selected dealer
    from_date: dayjs(fromDate).format('YYYY-MM-DD'), // Format from date as needed
    to_date: dayjs(toDate).format('YYYY-MM-DD'), // Format to date as needed
  })
  .then(response => {
    const orders = response.data?.ordersforammendment || [];
    setItems(orders.map(order => ({
      doctype_code: order.doctype_code,
      doc_no: order.doc_no,
      doc_date: order.doc_date,
      sap_no:order.sap_no,
    })));
    setDataFetched(true); 
    setOpen(false);
  })
  .catch(error => {
    console.error('Error fetching orders:', error);
    
    if (error.response && error.response.data) {
      const { message, status_code, text } = error.response.data;
      
      // Example: Check for specific error conditions
      if (status_code === "400" && text === "From Date Must Be Less Than ToDate") {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'From Date must be earlier than To Date.',
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: message || 'Failed to fetch orders. Please try again later.',
        });
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Failed to fetch orders. Please try again later.',
      });
    }
    
    setOpen(false); // Ensure setOpen(false) is called to close any loading indicators
  })
  .finally(() => {
    setLoading(false);
    setOpen(false);
  });
};


  useEffect(() => {
    // Function to fetch data from API
    const fetchData = async () => {
      setOpen(true);
      try {
        const response = await axios.post(BASE_URL + '/getdetailsforanorder', {
          login_id: login_id,
          document_no: editedDocumentType
        });

        
        const data = response.data;
        // Assuming API response has a key 'getdetailsforanorder' containing an array of objects
        setTableData2(data.getdetailsforanorder);
        // Calculate totalReqQty and totalAmount from the response data
        const reqQtySum = data.getdetailsforanorder.reduce((acc, curr) => acc + parseFloat(curr.QTY), 0);
        setTotalReqQty(reqQtySum);
        const amountSum = data.getdetailsforanorder.reduce((acc, curr) => acc + parseFloat(curr.TOT_BASE_PRICE), 0);
        setTotalAmount(amountSum);
        setOpen(false);
      } catch (error) {

        console.error('There was a problem fetching the data:', error);
        setOpen(false);
      }
    };

    if (openEditDialog) {
      fetchData();
      setOpen(false);
      setIsSaveButtonDisabled(true);
      setErrorMsg('');


    }
  }, [openEditDialog]);

  useEffect(() => {
    setOpen(true);
    // Fetch remarks data from the API
    axios.post(BASE_URL + '/getammendmentremarks', { login_id: login_id })
      .then(response => {
        const data = response.data?.ammendmentremarks || [];
        setRemarks(data);
        console.log('Remarks data:', data);
        setOpen(false);// Add this line to check the remarks data
      })
      .catch(error => {
        console.error('Error fetching remarks data:', error);
      });
  }, []);

  
  const handleChange = async (index, field, value, MAT_CODE) => {
    if (field === 'QTY' && (isNaN(value) || parseFloat(value) < 0)) {
      return;
    }
  

   
    const updatedTableData2 = [...tableData2];
    updatedTableData2[index][field] = value;
    if (field === 'QTY') {
      updatedTableData2[index].TOT_BASE_PRICE = (parseFloat(value) * parseFloat(updatedTableData2[index].BASIC_PRICE)).toFixed(2) || '0.00';
      let totalReqQtySum = 0;
      let totalAmountSum = 0;
        updatedTableData2.forEach((row) => {
        totalReqQtySum += parseFloat(row.QTY) || 0;
        totalAmountSum += parseFloat(row.TOT_BASE_PRICE) || 0;
      });
      setTotalReqQty(totalReqQtySum.toFixed(2));
      setTotalAmount(totalAmountSum.toFixed(2));
      setGrandTotal(totalAmountSum.toFixed(2)); 
    }
  

    const anyRemarkSelected = updatedTableData2.some(row => row.REMARKS && row.REMARKS !== '');
    setIsSaveButtonDisabled(!anyRemarkSelected );
  
    // Set the updated table data state
    setTableData2(updatedTableData2);
  };
  const handleSaveChanges = async () => {
    setOpen1(true);
    const requestData = {
      login_id: login_id,
      document_no: editedDocumentType,
      fyear: tableData2[0].FYEAR,
      po_value: grandTotal,
      item_list: tableData2.map(item => ({
        cancelled_quantity: (item.PENDINGTOINVOICE - item.QTY),
        document_item_no: item.DOC_ITEM_NO,
        mat_description: item.MAT_TEXT,
        mat_code: item.MAT_CODE.trim(),
        old_quantity: item.ORIGINAL_QTY,
        changed_quantity: item.QTY,
        basic_price: item.BASIC_PRICE,
        total_basic_price: item.TOT_BASE_PRICE,
        remarks: item.REMARKS
      }))
    };
  
    const errors = [];
  
    for (const item of tableData2) {
      try {
        const response = await axios.post(`${BASE_URL}/checkpackqty`, {
          login_id: login_id,
          ITEMCODE: item.MAT_CODE.trim(),
        });
  
        const pack_qty = parseFloat(response.data.pack_qty); // Convert pack_qty to a number
        if (pack_qty && (item.QTY !== '' && parseFloat(item.QTY) !== 0)) {
          const qty = parseFloat(item.QTY);
          const F_QTY = qty / pack_qty;
  
          if (F_QTY !== Math.round(F_QTY))
             {
              setOpen1(false);
            errors.push(
              `Pack quantity for '${item.MAT_TEXT}' must be in multiples of ${pack_qty}.`
            );
          }
        }
      } catch (error) {
        console.error(error);
        errors.push(
          `Error checking pack quantity for '${item.MAT_TEXT}'.`
        );
      }
    }
  
    if (errors.length > 0) {
      // Join errors into a single string with each error on a new line
      const formattedErrorMessages = errors.join('\n');
      
      setErrorMsg(formattedErrorMessages);
      setOpenEditDialog(true);
      return;
    }
  
    // Validate quantity
    const isQuantityValid = tableData2.every(item => {
      const qty = Number(item.QTY);
      const pending = Number(item.PENDINGTOINVOICE);
      return qty <= pending;
    });
  
    if (isQuantityValid) {
      try {
        // Proceed with the request
        const response = await axios.post(`${BASE_URL}/createammendmentagainstorder`, requestData);
        setOpenEditDialog(false);
        setOpen1(false);
        const isWarning = response.data.warning;
        const icon =  'success';
        const title = `Order No: ${editedDocumentType}`;
        Swal.fire({
          icon: icon,
          title: title,
          text: response.data.message || 'Operation completed',
        });
        GetTableDatas();
      } catch (error) {
        setOpen1(false);
        console.error('Error saving changes:', error);
        setOpenEditDialog(false);
        const errorMessage = error.response?.data?.message || 'An unexpected error occurred.';
        const isWarning = errorMessage.includes('specific condition');
        Swal.fire({
          icon: isWarning ? 'warning' : 'error',
          title: isWarning ? 'Warning' : 'Error',
          text: errorMessage,
        }).then((result) => {
          if (result.isConfirmed) {
            setOpenEditDialog(true);
          }
        });
      }
    } else {
      setOpenEditDialog(false);
      setOpen1(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Quantity should not exceed Pending Invoice Quantity',
      }).then((result) => {
        if (result.isConfirmed) {
          setOpenEditDialog(true);
        }
      });
    }
  };
  const getFullDocumentType = (type) => {
    switch (type) {
      case 'MPO':
        return 'Monthly Plan Order';
      case 'NPO':
        return 'Non Planned Order';
      case 'XPO':
        return 'XPRESS PLAN ORDER';
      default:
        return type; // return the type as it is if not found
    }
  };

  useEffect(() => {
    // Check if both dealer and dates are selected
    if (selectedDealer && fromDate && toDate) {
      setInputsFilled(true);
    } else {
      setInputsFilled(false);
    }
  }, [selectedDealer, fromDate, toDate]);

  const handleEdit1 = (index) => {
    setEditedRowIndex(index);
    const selectedRow = items[index];
    setEditedDocumentType(selectedRow.doc_no || '');
    setEditedDocumentType1(selectedRow.doctype_code || '');
    setEditedFyear(selectedRow.FYEAR || '');
  
    setOpenEditDialog(true);
  
    // Calculate grand total when dialog opens
    let totalReqQtySum = 0;
    let totalAmountSum = 0;
  
    tableData2.forEach((row) => {
      totalReqQtySum += parseFloat(row.QTY) || 0;
      totalAmountSum += parseFloat(row.TOT_BASE_PRICE) || 0;
    });
  
    // Set totalReqQty with 2 decimal places
    setTotalReqQty(totalReqQtySum.toFixed(2));
  
    // Ensure totalAmountSum is a number before formatting
    const roundedTotalAmount = totalAmountSum || 0; // Fallback to 0 if totalAmountSum is not a number
    
    // Set totalAmount and grandTotal with 2 decimal places
    const formattedAmount = roundedTotalAmount.toFixed(2);
  
    setTotalAmount(formattedAmount);
    setGrandTotal(formattedAmount);
  
    console.log('Edit clicked on index:', index);
  };

  const filteredItems = items.filter((row) => {
    return (
      row.doctype_code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.doc_no.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.doc_date.toLowerCase().includes(searchTerm.toLowerCase())||
      row.sap_no.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });


  return (
    <div>
      <Container >

        <br></br>
        <Box mb={2}>
          <Stack spacing={2} sx={{ width: '100%' }}>
            {/* Autocomplete for Dealer */}
            <Autocomplete
              id="dealer-autocomplete"
              freeSolo
              options={dealerOptions}
              value={selectedDealer}
              onInputChange={(event, newInputValue) => {
                setSelectedDealer(newInputValue);
              }}
              renderInput={(params) => <TextField {...params} label="Dealer Name - Code" />}
            />
          </Stack>
          <br></br>
      
          <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction="row" spacing={2} sx={{ width: '100%' }}>
        <div style={styles.datePickerWrapper}>
          <DatePicker
            selected={fromDate}
            onChange={handleFromDateChange}
            dateFormat="dd/MM/yyyy"
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            customInput={<StyledTextField variant="outlined" label="From Date" />}
          />
        </div>
        <div style={styles.datePickerWrapper}>
          <DatePicker
            selected={toDate}
            onChange={handleToDateChange}
            dateFormat="dd/MM/yyyy"
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            customInput={<StyledTextField variant="outlined" label="To Date" />}
          />
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={GetTableDatas}
          disabled={!inputsFilled} 
        >
          View Orders
        </Button>
      </Stack>
    </LocalizationProvider>
       
         
          <br></br>
          <br></br>


          {/* Table */}
          {dataFetched && (
        <>
          <TextField
            id="filled-search"
            label="Search"
            type="search"
            variant="filled"

            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              endAdornment: <SearchIcon />,
            }}
          />

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TableContainer
                component={Paper}
                sx={{ width: '100%', maxHeight: '400px', overflow: 'auto' }}
              >
                <Table stickyHeader size="small" aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={styles.dialogTitle}>Order Type</TableCell>
                      <TableCell sx={styles.dialogTitle}>Order Number</TableCell>
                      <TableCell sx={styles.dialogTitle}>SAP Order Number</TableCell>
                      <TableCell sx={styles.dialogTitle}>Order Date</TableCell>
                      <TableCell sx={styles.dialogTitle}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredItems.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={4} align="center">
                          No data available
                        </TableCell>
                      </TableRow>
                    ) : (
                      filteredItems.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            '&:hover': { backgroundColor: '#f9f9f9' },
                            ...styles.tableRow,
                            height: '40px',
                          }}
                        >
                          <TableCell sx={{ ...styles.customCell }}>{row.doctype_code}</TableCell>
                          <TableCell sx={{ ...styles.customCell }}>{row.doc_no}</TableCell>
                          <TableCell sx={{ ...styles.customCell }}>{row.sap_no}</TableCell>
                          <TableCell sx={{ ...styles.customCell }}>{row.doc_date}</TableCell>
                          <TableCell>
                            <IconButton onClick={() => handleEdit1(index)} variant="outlined" color="primary">
                              <EditIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </>
      )}
          {/* Edit Dialog */}
          <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)} maxWidth="xl" fullWidth>

            <DialogTitle sx={styles.dialogTitle}>{`${getFullDocumentType(editedDocumentType1)}No:${editedDocumentType} `}</DialogTitle>

            <div style={{ overflowX: 'auto' }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Table  size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ ...styles.tableHeaderCell, position: 'sticky', top: 0, zIndex: 1 }} width="auto">PSG</TableCell>

                        <TableCell sx={{ ...styles.tableHeaderCell, position: 'sticky', top: 0, zIndex: 1 }} width="auto">Item Details</TableCell>
                        <TableCell sx={{ ...styles.tableHeaderCell, position: 'sticky', top: 0, zIndex: 1 }} width="auto">Req.QTY</TableCell>
                        <TableCell sx={{ ...styles.tableHeaderCell, position: 'sticky', top: 0, zIndex: 1 }} width="auto">Price</TableCell>
                        <TableCell sx={{ ...styles.tableHeaderCell, position: 'sticky', top: 0, zIndex: 1 }} width="auto">Total</TableCell>
                        <TableCell sx={{ ...styles.tableHeaderCell, position: 'sticky', top: 0, zIndex: 1 }} width="auto">Remarks</TableCell>
                        <TableCell sx={{ ...styles.tableHeaderCell, position: 'sticky', top: 0, zIndex: 1 }} width="auto">Ordered.QTY</TableCell>
                        <TableCell sx={{ ...styles.tableHeaderCell, position: 'sticky', top: 0, zIndex: 1 }} width="auto">Billed.QTY</TableCell>
                        <TableCell sx={{ ...styles.tableHeaderCell, position: 'sticky', top: 0, zIndex: 1 }} width="auto">Pending to be Billed</TableCell>
                      </TableRow>
                    </TableHead>
                    {/* Table Body */}
                    <TableBody style={{ tableLayout: 'auto' }}>
  {tableData2.map((row, index) => (
    <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#f9f9f9' }, ...styles.tableRow }}>
      <TableCell>{row.MATSUBGROUP_DESC}</TableCell>
      <TableCell>{row.MAT_CODE}-{row.MAT_TEXT}</TableCell>
      <TableCell>
        <TextField
          type="number"
          value={row.QTY === '' ? '' : parseFloat(row.QTY) || 0}
          onChange={(e) => handleChange(index, 'QTY', e.target.value === '' ? '' : e.target.value, row.MAT_CODE)}
          onKeyDown={(e) => {
            if (e.key === '.' || e.key === 'e') {
              e.preventDefault();
            }
          }}
          style={{ width: '80px' }}
          inputProps={{
            style: {
              color: parseFloat(row.QTY) > parseFloat(row.PENDINGTOINVOICE) ? 'red' : 'inherit'
            }
          }}
        />
      </TableCell>
      <TableCell>{formatToINR(row.BASIC_PRICE)}</TableCell>
      <TableCell>{formatToINR(row.TOT_BASE_PRICE)}</TableCell>
      <TableCell width="100%">
        <TextField
          select
          style={{ width: '200px' }}
          value={row.REMARKS || ''}
          onChange={(e) => handleChange(index, 'REMARKS', e.target.value)}
        >
          {remarks.map((remark, index) => (
            <MenuItem key={index} value={remark.name}>
              {remark.name}
            </MenuItem>
          ))}
        </TextField>
      </TableCell>
      <TableCell>{row.ORIGINAL_QTY}</TableCell>
      <TableCell>{row.billedqty}</TableCell>
      <TableCell>{parseFloat(row.PENDINGTOINVOICE).toFixed(2)}</TableCell>
    </TableRow>
  ))}

  {/* Grand Total Row */}
  <TableRow style={{ position: 'sticky', bottom: 0, backgroundColor: '#f2f2f2', width: '100%', zIndex: 1 }}>
    <TableCell colSpan={2} style={{ width: '100%', textAlign: 'right', fontWeight: 'bold' }}>
      <b sx={styles.grandTotalLabel}> Total</b>
    </TableCell>
    <TableCell align="center" style={{ fontWeight: 'bold' }}>{totalReqQty}</TableCell>
    <TableCell></TableCell>
    <TableCell align="center" style={{ fontWeight: 'bold' }}>
      {formatToINR(parseFloat(totalAmount || 0).toFixed(2))}
    </TableCell>
    <TableCell></TableCell>
    <TableCell></TableCell>
    <TableCell></TableCell>
    <TableCell></TableCell>
  </TableRow>
</TableBody>
                  </Table>
                </Grid >
              </Grid>
			      {ErrorMsg &&
                                        <>
                                            <br />
                                            <center>
                                                <span style={{ color: 'red' }}>* {ErrorMsg}</span>
                                            </center>
                                        </>
                                    }
            </div>

            {/* Dialog Actions */}
            <DialogActions>
  <Button onClick={() => setOpenEditDialog(false)} color="error">Cancel</Button>
  <Button onClick={handleSaveChanges} color="primary" disabled={isSaveButtonDisabled}>Save Changes</Button>
</DialogActions>
<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open1} >
        <CircularProgress color="inherit" />
      </Backdrop>
          </Dialog>

        </Box>
      </Container>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default POdetails;
